import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

export default function useDebtReportList(params) {
  return useSWR(
    !params?.fromDate === !params?.toDate
      ? {
          path: "/api/v1/reports",
          method: "GET",
          params: {
            limit: 50,
            skip: 0,
            ...params,
          },
        }
      : null,
    fetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
